export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('form-row');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;
    const TYPE_NAME = "DNI";
    const DATA_TYPE_ATTR_NAME = "data-lg-type";

    var model = MODEL.extend({

        defaults: {
            ...MODEL.prototype.defaults,
            'custom-name': `C-${TYPE_NAME}`,
            attributes: {
                [DATA_TYPE_ATTR_NAME]: `C-${TYPE_NAME}`
            },
            classes: ['form-row'],
            components: [
                {
                    type: "input",
                    attributes: {
                        type: "text",
                        name: "dni",
                        placeholder: 'Insert your DNI',
                        "data-slg-validate-pattern": "((([X-Zx-z])|([LMlm])){1}([-]?)((\\d){7})([-]?)([A-Za-z]{1}))|((\\d{8})([-]?)([A-Za-z]))",
                        "data-slg-control-max-length": 9,
                        required: true
                    },
                    droppable: false,
                    draggable: false,
                    removable: false,
                    copyable: false,
                    // selectable: false,
                    hoverable: false,
                    classes: ['form-control']
                },
                {
                    type: "invalid-feedback",
                    droppable: false,
                    draggable: false,
                    content: "Enter a valid DNI"
                }

            ]
        },
        init() {
            let firstChild = this.components().at(0);
            firstChild.removeTrait([
                // "data-slg-control-max-length",
                "data-slg-control-type",
                "data-slg-follow-in-query",
                "data-slg-validate-pattern",
                "type"
            ]);
        },
    }, {
        isComponent(el) {
            if (el && el.getAttribute && el.getAttribute(DATA_TYPE_ATTR_NAME) == `C-${TYPE_NAME}`)
                return { type: `C-${TYPE_NAME}` }
        }
    });

    var view = VIEW.extend({
    });

    DOMC.addType(`C-${TYPE_NAME}`, {
        model: model,
        view: view,
    });

    BM.add(`B-${TYPE_NAME}`, {
        label: `${TYPE_NAME}`,
        content: {
            type: `C-${TYPE_NAME}`,
        },
        category: "ADVANCE COMPONENT",
    });
};
